/*
 * Copyright (c) Castle Point Learning Systems Corporation, 2013-2023, all rights reserved.
 * NOTICE: Dissemination of the information and/or materials contained in this file is strictly
 * forbidden unless prior written permission is obtained from Castle Point Learning Systems Corporation.
 * See LICENSE.txt (part of this package) for the full notice.
 */

import {Dispatch, SetStateAction, useCallback, useState} from "react";

export function usePreviousState<T>(current: T): [T, Dispatch<SetStateAction<T>>] {
    const [queue] = useState<T[]>(() => [current])
    const [previous, setPrevious] = useState<T>()

    const setValue = useCallback((value: T) => {
        queue.push(value)
        setPrevious(queue.shift())
    }, [queue])

    return [previous, setValue]
}